//import EventBus from "../components/event-bus";
export const contractMixins =  {

    data: () => ({

    }),
    mounted: function() {

    },

    methods: {

        loadFieldData(flagArr,flag = '',id='') {
        // return false;
          // console.log(flagArr.indexOf("schedule_payment_"));

            var self = this;
            $.ajax({
                url: process.env.ROOT_API + "/common/field-data",
                type: "POST",
                headers: this.ajxHeaders,
                crossDomain: true,
                data:{'params':flagArr,'flag' : flag,'id' : id},
                dataType: 'json',
                success: function (data) {
                    if (data.status == "success") {
                        self.loading = false;

                      flagArr.forEach(element => {

                        if(element.includes("schedule_payment_")) {
                          self.schedulePaymentArr = data.content.schedule_payment;
                        }

                      });

                        // if ( flagArr.indexOf("schedule_payment") > -1 ) {
                        //   console.log("schedulePaymentArr ==", data.content);
                        //     console.log("schedulePaymentArr ==", self.schedulePaymentArr);
                        // } else {
                        //   console.log("flagArr ==", flagArr);
                        //   console.log("== NOO  ==");
                        // }
                        if ( flagArr.indexOf("term") > -1 ) {
                            self.termArr = data.content.term;
                        }
                        if ( flagArr.indexOf("creditManager") > -1 ) {
                            self.creditManagerArr = data.content.creditManager;
                        }
                        if ( flagArr.indexOf("contractTypeWithAll") > -1 || flagArr.indexOf("contractTypeWithSpecific") > -1 || flagArr.indexOf("invcontractType") > -1 ) {
                            self.contractTypeArr = data.content.contract_type;
                        }
                        if ( flagArr.indexOf("contractType") > -1 ) {
                            self.contractTypeArr = data.content.contract_type;
                        }
                        if ( flagArr.indexOf("location") > -1 ) {
                            self.locationArr = data.content.location;
                        }
                        if ( flagArr.indexOf("role") > -1 ) {
                            self.roleArr = data.content.role;
                        }
                        if ( flagArr.indexOf("timezone") > -1 ) {
                            self.timezoneArr = data.content.timezone;

                            //displayed us pacific timezone as selected default
                            for (var i = 0; i < self.timezoneArr.length; i++) {
                                if ( self.timezoneArr[i].text.toLowerCase() == "us: pacific time") {
                                    self.selectTimeZone = {value:self.timezoneArr[i].value,text:self.timezoneArr[i].text}
                                }
                            }
                        }
                        if ( flagArr.indexOf("equipment-osr-asset-pool") > -1 ) {
                            self.assetpoolArr = data.content.asset_pool;
                        }
                        if ( flagArr.indexOf("gl_account") > -1 ) {
                            self.glAccountArr = data.content.gl_account;
                        }
                        if ( flagArr.indexOf("contractBillingMethod") > -1 ) {
                            self.contractBillingMethodArr = data.content.contract_billing_method;
                        }
                        if ( flagArr.indexOf("contractBillingFreq") > -1 ) {
                            self.contractBillingFrequencyArr = data.content.contract_billing_frequency;
                        }
                        if ( flagArr.indexOf("cpiCode") > -1 ) {
                            self.cpiCodeArr = data.content.cpi_code;
                            var obj = self.cpiCodeArr;

                            $.each(obj, function (key, cpivalue) {
                                                        if (cpivalue.code == 'CPI84') {
                                                            self.cpi_code_id = {
                                                                value: cpivalue.value,
                                                                text: cpivalue.text,
                                                            };
                                                        }
                                // console.log(cpivalue);
                                                    });
                        }
                        if ( flagArr.indexOf("section") > -1 ) {
                            self.sectionArr = data.content.sections;
                        }
                        if ( flagArr.indexOf("vom") > -1 ||  flagArr.indexOf("measurementUnit") > -1  ) {
                            self.vomArr = data.content.vom;
                            self.purchaseunitArr = data.content.vom;
                            self.stockunitArr = data.content.vom;
                            if (flagArr.indexOf("measurementUnit") > -1){
                                    var obj = self.vomArr;
                                    $.each(obj, function (key, uomvalue) {
                                        if (uomvalue.symbol == 'GAL') {
                                            self.measurement_unit_id = {
                                                value: uomvalue.value,
                                                text: uomvalue.text,
                                            };
                                        }
                                    });

                            }
                        }
                        if ( flagArr.indexOf("selectedmeasurementUnit") > -1 ) {
                            self.vomArr = data.content.vom;
                        }
                        if ( flagArr.indexOf("vehicleType") > -1 || flagArr.indexOf("rentalVehicleType") > -1 ) {
                            self.vehicleTypeArr = data.content.vehicleType;
                        }
                        if ( flagArr.indexOf("permitType") > -1 ) {
                          self.permitTypeArr = data.content.permitType;
                        }
                        if ( flagArr.indexOf("saleRep") > -1 ) {
                          self.saleRepArr = data.content.saleRep;
                        }
                        if ( flagArr.indexOf("source") > -1 ) {
                            self.sourcesArr = data.content.source;
                        }
                        if ( flagArr.indexOf("status") > -1 ) {
                            self.statusArr = data.content.status;
                        }
                        if ( flagArr.indexOf("shop") > -1 ) {
                            self.shopArr = data.content.shop;
                        }
                        if ( flagArr.indexOf("work_order_comment") > -1 ) {
                            self.commentTypeArr = data.content.comment;
                        }
                        if ( flagArr.indexOf("policy_comment") > -1 ) {
                            self.commentTypeArr = data.content.comment;
                        }
                        if ( flagArr.indexOf("reason") > -1 ) {
                            self.reasonArr = data.content.reason;
                        }
                        if ( flagArr.indexOf("priority") > -1 ) {
                            self.priorityArr = data.content.priority;
                        }
                        if ( flagArr.indexOf("costcode") > -1 ) {
                            self.costCodeArr = data.content.costcode;
                        }
                        if ( flagArr.indexOf("billablecode") > -1 || flagArr.indexOf("fuelbillablecode") > -1) {
                            self.billableCodeArr = data.content.billablecode;
                            // self.vomArr = data.content.vom;
                            if (flagArr.indexOf("fuelbillablecode") > -1){
                                var obj = self.billableCodeArr;
                                $.each(obj, function (key, billvalue) {
                                    if (billvalue.value == '1') {
                                        self.bill_type = {
                                            value: billvalue.value,
                                            text: billvalue.text,
                                        };
                                    }
                                });

                            }
                        }
                        if ( flagArr.indexOf("standarddefects") > -1 ) {
                            self.standardDefectsArr = data.content.standarddefects;
                        }
                        if ( flagArr.indexOf("workordertask") > -1 ) {
                            self.workOrderTaskArr = data.content.workordertask;
                        }
                        if ( flagArr.indexOf("indirectlaborcode") > -1 ) {
                          self.indirectLaborCodeArr = data.content.indirectlaborcode;
                        }
                        if ( flagArr.indexOf("rental_locations") > -1 ) {
                            self.locationArr = data.content.location;
                        }
                        if ( flagArr.indexOf("job_locations") > -1 ) {
                            self.locationArr = data.content.location;
                        }
                        if ( flagArr.indexOf("ins_locations") > -1 ) {
                            self.insLocationArr = data.content.location;
                        }
                        if ( flagArr.indexOf("module") > -1 ) {
                            self.moduleArr = data.content.module;
                        }
                        if ( flagArr.indexOf("activity_type") > -1 ) {
                            self.activityTypeArr = data.content.activityType;
                        }
                        if ( flagArr.indexOf("unit_reading_sections") > -1 ) {
                            self.unitReadingsSectionArr = data.content.unitReadingsSection;
                        }
                        if ( flagArr.indexOf("added_by") > -1 ) {
                            self.addedByArr = data.content.addedBy;
                        }
                        if ( flagArr.indexOf("reservation_status") > -1 ) {
                            self.reservationStatusArr = data.content.reservationStatus;
                        }
                        if ( flagArr.indexOf("component_category") > -1 ) {
                            self.componentCategoryArr = data.content.componentCategory;
                        }
                        if ( flagArr.indexOf("work_order_status") > -1 ) {
                            self.workOrderStatusArr = data.content.workOrderStatus;
                        }
                        if ( flagArr.indexOf("work_order_estimate_status") > -1 ) {
                            self.workOrderEstimateStatusArr = data.content.workOrderEstimateStatus;
                        }
                        if ( flagArr.indexOf("maintenance_type") > -1 ) {
                            self.maintenanceTypeArr = data.content.maintenanceType;
                        }
                        if ( flagArr.indexOf("customer_response_status") > -1 ) {
                            self.customerResponseStatusArr = data.content.customerResponseStatus;
                        }
                        if ( flagArr.indexOf("response_type") > -1 ) {
                            self.customerResponseTypeArr = data.content.customerResponseType;
                        }
                        if ( flagArr.indexOf("insurance_agency") > -1 ) {
                            self.insuranceAgencyArr = data.content.insuranceAgency;
                        }
                        if ( flagArr.indexOf("rentalContractType") > -1 ) {
                            self.contractTypeArr = data.content.rentalContractType;
                        }
                        if ( flagArr.indexOf("checkListAction") > -1 ) {
                            self.checkListActionArr = data.content.checkListAction;
                        }
                        if ( flagArr.indexOf("activityModule") > -1 ) {
                            self.activityModuleArr = data.content.activityModule;
                        }
                        if ( flagArr.indexOf("accountTypes") > -1 ) {
                            self.accountTypesArr = data.content.accountTypes;
                            var prevSelectedTab = localStorage.getItem("gl_list_prev_tab");
                            setTimeout(function() {
                                $(".tab-buttons").removeClass("active");
                                $("#tab_" + parseInt(prevSelectedTab)).addClass("active");
                            }, 1000);
                        }
                        if ( flagArr.indexOf("ownership") > -1 ) {
                            self.ownershipArr = data.content.ownership;
                        }
                        if ( flagArr.indexOf("invoiceTypes") > -1 || flagArr.indexOf("manualInvoiceTypes") > -1) {
                            self.invoiceTypesArr = data.content.invoiceTypes;
                        }
                        if ( flagArr.indexOf("taxes") > -1 ) {
                            self.taxesArr = data.content.taxes;
                        }
                        if ( flagArr.indexOf("terms") > -1 ) {
                            self.termsArr = data.content.terms;
                        }
                        if ( flagArr.indexOf("taxes") > -1 ) {
                            self.taxesArr = data.content.taxes;
                        }
                        if ( flagArr.indexOf("cost_types") > -1 ) {
                            self.costTypesArr = data.content.cost_types;
                        }
                        if ( flagArr.indexOf("rate_types") > -1 ) {
                            self.rateTypesArr = data.content.rate_types;
                        }
                        if ( flagArr.indexOf("charges") > -1 || flagArr.indexOf("vendor_po_charges") > -1 ) {
                            self.chargesArr = data.content.charges;
                        }
                        if ( flagArr.indexOf("customer_charges") > -1 ) {
                            self.chargesArr = data.content.customer_charges;
                        }
                        if ( flagArr.indexOf("vehicle") > -1 ) {
                            self.allVehicleArr = data.content.vehicle;
                        }
                        if ( flagArr.indexOf("contract_misc_charges") > -1 ) {
                            self.contractChargesArr = data.content.contract_misc_charges;
                        }
                        if ( flagArr.indexOf("asset_feature_category") > -1 ) {
                            self.assetFeatureCategoryArr = data.content.assetFeatures;
                        }
                        if ( flagArr.indexOf("feature") > -1 ) {
                            self.featureValArr = data.content.feature;
                        }
                        if ( flagArr.indexOf("business_type") > -1 ) {
                            self.businessTypeArr = data.content.businessTypes;
                        }
                        if ( flagArr.indexOf("hvut_categories") > -1 ) {
                            self.hvutCategoriesArr = data.content.hvutCategories;
                        }
                        if ( flagArr.indexOf("customer_comment") > -1 ) {
                            self.commentTypeArr = data.content.comment;
                        }
                        if ( flagArr.indexOf("warranty_claim_comment") > -1){
                            self.commentTypeArr = data.content.comment;
                        }
                        if ( flagArr.indexOf("asset_comment") > -1 ) {
                            self.commentTypeArr = data.content.comment;
                        }
                        if ( flagArr.indexOf("financial_period") > -1 ) {
                            self.financialPeriodsArr = data.content.financial_period;
                        }
                        if ( flagArr.indexOf("vendorInvoicePaymentTypes") > -1 ) {
                            self.paymentTypesArr = data.content.vendorInvoicePaymentTypes;
                        }
                        if ( flagArr.indexOf("tank_by_location") > -1 ) {
                            self.tankArr = data.content.tankData;
                        }
                        if ( flagArr.indexOf("customerClass") > -1 ) {
                            self.customerClassArr = data.content.customerClass;
                        }
                        if ( flagArr.indexOf("fuelItems") > -1 || flagArr.indexOf("internalFuel") > -1 ) {
                            self.componentArr = data.content.fuelItems;
                        }
                        if ( flagArr.indexOf("fuelLocations") > -1 ) {
                            self.locationArr = data.content.fuelLocations;
                        }
                        if ( flagArr.indexOf("fuelislandproduct") > -1 || flagArr.indexOf("fuelislandproductfueler") > -1 ) {
                            self.productArr = data.content.fuelIslandProducts.content;
                            if(flagArr.indexOf("fuelislandproductfueler") > -1)
                            {
                                if(data.content.fuelIslandProducts.status=='location_error')
                                {
                                    self.user_location_error="User not mapped with any location please contact admin.";
                                }
                            }
                        }
                        if ( flagArr.indexOf("glSrcCodes") > -1 ) {
                            self.glSrcCodesArr = data.content.glSrcCodes;
                        }

                        if ( flagArr.indexOf("depriciation_type") > -1 ) {
                            self.scheduleTypeArr = data.content.types;
                        }
                        if ( flagArr.indexOf("warehouse") > -1 ) {
                            self.warehouseArr = data.content.warehouse;
                        }
                        if ( flagArr.indexOf("receiving_warehouse") > -1 ) {
                            self.warehouseArr = data.content.receiving_warehouse;
                        }
                        if ( flagArr.indexOf("fuel_warehouse") > -1 ) {
                          self.warehouseArr = data.content.fuel_warehouse;
                        }
                        if ( flagArr.indexOf("non_fuel_warehouse") > -1 ) {
                          self.warehouseArr = data.content.non_fuel_warehouse;
                        }
                        if ( flagArr.indexOf("rsb") > -1 ) {
                            self.rsbArr = data.content.rsb;
                        }
                        if ( flagArr.indexOf("to_rsb") > -1 ) {
                            self.torsbArr = data.content.rsb;
                        }
                        if ( flagArr.indexOf("vehicle_pool") > -1 ) {
                          self.assetPoolArr = data.content.vehicle_pool;
                        }
                        if ( flagArr.indexOf("base_scope") > -1 ) {
                            self.baseScopeArr = data.content.base_scope;
                        }
                        if ( flagArr.indexOf("manual_invoice_charges") > -1 ) {
                            self.chargesArr = data.content.manual_invoice_charges;
                        }
                        if ( flagArr.indexOf("receipt") > -1 ) {
                            self.receiptArr = data.content.receipt;
                        }
                        if ( flagArr.indexOf("notification_types") > -1 ) {
                            self.notificationTypesArr = data.content.notificationTypes;
                        }
                        if ( flagArr.indexOf("vendor_comment") > -1 ) {
                            self.commentTypeArr = data.content.comment;
                        }
                        if ( flagArr.indexOf("invoice_comment") > -1 ) {
                            self.commentTypeArr = data.content.comment;
                        }
                        if ( flagArr.indexOf("payment_comment") > -1 ) {
                            self.commentTypeArr = data.content.comment;
                        }
                        if ( flagArr.indexOf("all_comment") > -1 ) {
                            self.commentTypeArr = data.content.comment;
                        }
                        if ( flagArr.indexOf("vehicle_manufacturer") > -1 ) {
                            self.vehicleManufacturerArr = data.content.vehicle_manufacturer;
                        }
                        if ( flagArr.indexOf("vehicle_model") > -1 ) {
                            self.vehicleModelArr = data.content.vehicle_model;
                        }
                        if ( flagArr.indexOf("vehicle_group") > -1 ) {
                            self.vehicleGroupArr = data.content.vehicle_group;
                        }
                        if ( flagArr.indexOf("vehicle_year") > -1 ) {
                            self.vehicleYearArr = data.content.vehicle_year;
                        }
                        if ( flagArr.indexOf("disposal_representative") > -1 ) {
                            self.representativeArr = data.content.representativeArr;
                        }
                        if ( flagArr.indexOf("paymentOptions") > -1 ) {
                            self.paymentOptionsArr = data.content.paymentOptions;
                        }
                        if ( flagArr.indexOf("customer_representative") > -1 ) {
                            self.customerRepresentativeArr = data.content.customerRepresentativeArr;
                        }
                        if ( flagArr.indexOf("requisition_representative") > -1 ) {
                          self.requisitionRepresentativeArr = data.content.requisitionRepresentativeArr;
                        }
                        if ( flagArr.indexOf("program") > -1 ) {
                            self.programArr = data.content.programArr;
                          }
                        if ( flagArr.indexOf("mso_charges") > -1 ) {
                            self.chargesArr = data.content.mso_charges;
                        }
                        if ( flagArr.indexOf("vendor_po_charges") > -1 ) {
                            self.defaultChargesArr = data.content.charges;
                        }
                        if ( flagArr.indexOf("technician_users") > -1 ) {
                            self.techUsersArr = data.content.technician_users;
                        }
                        if ( flagArr.indexOf("technician") > -1 ) {
                            self.techArr = data.content.technician;
                        }
                        if ( flagArr.indexOf("pump_mapper") > -1 ) {
                            self.pumpMapperArr = data.content.pump_data;
                        }
                        if ( flagArr.indexOf("tank_mapper") > -1 ) {
                            self.tankMapperArr = data.content.tank_data;
                        }
                        if ( flagArr.indexOf("claim_types") > -1 ) {
                            self.claimTypeArr = data.content.claim_types;
                        }
                        if ( flagArr.indexOf("ev_claim_types") > -1 ) {
                          self.claimTypeArr = data.content.ev_claim_types;
                      }
                        if ( flagArr.indexOf("enable_asset_group") > -1 ) {
                            self.isEnableAssetGroup = data.content.enable_asset_group;
                        }
                        if ( flagArr.indexOf("enable_asset_pool") > -1 ) {
                            self.isEnableAssetPool = data.content.enable_asset_pool;
                        }
                        if ( flagArr.indexOf("customer_address") > -1 ) {
                            self.customerAddressArr = data.content.customer_address;
                            self.APIResponse = true;
                        }

                        if ( flagArr.indexOf("publication_depart_doc_type") > -1 ) {
                            self.departmentArr = data.content.publi_depart_doc_data.departments;
                            self.documenttypeArr = data.content.publi_depart_doc_data.documentTypes;
                        }
                      if ( flagArr.indexOf("campaign_vehicle_status") > -1 ) {
                        self.vinStatusArr = data.content.campaign_vehicle_status.map(value => {
                            return {
                              value: value,
                              text: value.replace(/\b\w/g, char => char.toUpperCase())
                            };
                        });
                      }
                      if ( flagArr.indexOf("dealerShipTo") > -1 ) {
                        self.dealerShipTo = data.content.dealerShipTo;
                       }
                       if ( flagArr.indexOf("dealerDetails") > -1 ) {
                        self.dealerDetails = data.content.dealerDetails;
                       }
                       if ( flagArr.indexOf("user_quick_links") > -1 ) {
                        self.userQuickLinks = data.content.user_quick_links;
                       }
                       if ( flagArr.indexOf("quick_links") > -1 ) {
                        self.quickLinks = data.content.quick_links;
                       }
                       if ( flagArr.indexOf("social_links") > -1 ) {
                        self.instaLink = data.content.social_links.instagram_link;
                        self.linkedinLink = data.content.social_links.linkedin_link;
                       }
                       if ( flagArr.indexOf("vehicle_options") > -1 ) {
                        self.vehicleOptionArr = data.content.vehicle_options;
                       }
                      if ( flagArr.indexOf("vehicle_option_codes") > -1 ) {
                        self.vehicleOptionCodesArr = data.content.vehicle_option_codes;
                      }
                       if(flagArr.indexOf("state_codes") > -1){
                         self.stateArr = data.content.state_codes;
                       }
                       if(flagArr.indexOf("system_params_search") > -1){
                        self.systemParamValue = data.content.system_params_search;
                      }
                      if(flagArr.indexOf("single_customer") > -1){
                        self.dealer_id = data.content.single_customer;
                        self.dealerArr = Array.isArray(data.content.single_customer) 
                            ? data.content.single_customer 
                            : [data.content.single_customer];
                      }
                      if(flagArr.indexOf("claim_campaigns") > -1){
                        self.campaignArr = data.content.claim_campaigns;
                      }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.Registerbtn = "Register";
                    if (jqXHR.status == 0) {
                        self.registerError = "Remote server cannot be reached";
                    }
                }
            });
        },

    }
}



// WEBPACK FOOTER //
// ./src/mixins/contractMixins.js